import { define, Model, AttributesMixin } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { Payment } from "./payment";

export interface ManualPayment extends AttributesMixin<typeof ManualPayment> { }
@define
export class ManualPayment extends Model {
    static endpoint = restfulIO('api/v1/ingest/payments');

    static attributes = {
        id: String,
        status: String,
        ...Payment.attributes
    }

    resolveIssues() {
        return this.errors;
    }
}
